// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminSubscriptionProcessResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminSubscriptionProcessResponse — result of
 * POST /subscriptions/admin/subscriptions/{id}/process (S12/#17a).
 *
 * The sweep's per-row path, aimed at ONE subscription a human named. It reports
 * WHAT HAPPENED, and every one of those answers is a success envelope: the
 * mechanism ran. Only three things leave this endpoint through sendError() —
 * the auth gate, an unparseable/unknown id (subscription_not_found), and an
 * unexpected exception. A refusal by the gateway is NOT one of them: it is a
 * verdict the staff asked the mechanism to go and fetch, and burying it in an
 * error toast loses the reason.
 *
 * Contrast with POST /subscriptions/admin/cancel (Subscriptions_AdminCancelResponse),
 * which sendError()s every non-cancelled outcome. That endpoint is an ORDER
 * ("cancel this") and anything but a cancellation means the order was not
 * carried out. This one is a QUESTION ("what does the sweep do with this row
 * today?") and 'not_due' or 'deferred' are correct answers to it.
 *
 * outcome ∈ {not_due, cancelled, deferred, refused, gateway_failed, local_write_failed}
 *   not_due            — the carência window is still open (cut at end of day)
 *   cancelled          — provider cancelled, local row followed. Terminal.
 *   deferred           — the provider still has a payment retry scheduled
 *   refused            — no reachable gateway for this provider
 *   gateway_failed     — the provider was reached and said no. Nothing local moved.
 *   local_write_failed — the provider cancelled but our write failed. Divergence.
 *
 * reason carries the machine code behind a non-cancellation ('retry_scheduled',
 * 'gateway_not_registered', 'gateway_cannot_cancel', 'gateway_cancel_failed: …').
 * It is null for 'cancelled' and for 'not_due' — neither has a reason to give.
 *
 * status is the status the row holds NOW, after the call.
 *
 * cutoff is the end-of-day boundary the decision was made against, emitted as
 * ISO 8601 UTC like every other datetime on the wire — it is a GMT-3 midnight,
 * so it renders as the previous day at 03:00Z. It is what makes 'not_due'
 * auditable instead of merely asserted.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_AdminSubscriptionProcessResponseDados {
subscription_id: number
outcome: string
status: string
reason: string
cutoff: string
}

export type Subscriptions_AdminSubscriptionProcessResponse = ApiResponse<Subscriptions_AdminSubscriptionProcessResponseDados>;

registerResponseContract('Subscriptions_AdminSubscriptionProcessResponse', {
  subscription_id: { type: 'number',  required: true },
  outcome:         { type: 'string',  required: true },
  status:          { type: 'string',  required: false },
  reason:          { type: 'string',  required: false },
  cutoff:          { type: 'string',  required: false },
})
